module.exports = __webpack_public_path__ + "img/bg-banner.6b865232.png";